import { Card, Box, Typography } from '@mui/material';

//Gráficos
import GraficoEstadoIntervencoesDepartamento from '../dashboard/Graficos/GraficoEstadoIntervencoesDepartamento';
import GraficoValorIntervencoesAdjudicadas from '../dashboard/Graficos/GraficoValorIntervencoesAdjudicadas';
import GraficoEstadoIntervencoes from '../dashboard/Graficos/GraficoEstadoIntervencoes';
import GraficoTaxaSucesso from '../dashboard/Graficos/GraficoTaxaSucesso';
import GraficoPercInterAdjudicada from '../dashboard/Graficos/GraficoPercInterAdjudicada';

const DesktopDash = ({ dimensions, dashInfoResumo, dashInfo }) => {
  return (
    <>
      <div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '39%',
            }}
          >
            <div
              style={{
                display: 'flex',
                // justifyContent: 'space-between',
                flexWrap: 'wrap',
              }}
            >
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {new Intl.NumberFormat('pt-PT', {
                    style: 'currency',
                    currency: 'EUR',
                  }).format(dashInfoResumo && dashInfoResumo.valorAdjudicado)}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#DDF6FF',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Valor adjudicado
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {dashInfoResumo && dashInfoResumo.totalIntervencoes}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#E2FEDE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Pedidos de Intervenções
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {dashInfoResumo && dashInfoResumo.intervencoesRespondidas}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#E2FEDE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Intervenções Respondidas
                  </span>
                </Typography>
              </Box>
              {/* --- */}

              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {dashInfoResumo && dashInfoResumo.intervencoesPorResponder}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#FFDFE8',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Intervenções Não Respondidas
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {Math.floor(
                    dashInfoResumo && dashInfoResumo.idadeMediaIntervencoes
                  )}{' '}
                  dias
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#E2FEDE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Idade Média das Intervenções
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {Math.floor(
                    dashInfoResumo && dashInfoResumo.tempoMedioResposta
                  )}{' '}
                  dias
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#FFF7CE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Tempo médio de resposta
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {dashInfoResumo && dashInfoResumo.intervencoesAguardaResposta
                    ? dashInfoResumo.intervencoesAguardaResposta
                    : 0}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#FFF7CE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Intervenções Em Espera
                  </span>
                </Typography>
              </Box>
              <Box
                sx={
                  dimensions.width > 1890
                    ? { minWidth: '33%' }
                    : { minWidth: '50%' }
                }
              >
                <Typography sx={{ fontSize: 20, fontWeight: '900' }}>
                  {dashInfoResumo && dashInfoResumo.intervencoesAguardaRevisao
                    ? dashInfoResumo.intervencoesAguardaRevisao
                    : 0}
                </Typography>
                <Typography sx={{ fontSize: 15, mt: 1 }}>
                  <span
                    style={{
                      backgroundColor: '#FFF7CE',
                      paddingLeft: '7px',
                      paddingRight: '7px',
                      borderRadius: '10px',
                    }}
                  >
                    Intervenções Em Revisão
                  </span>
                </Typography>
              </Box>
            </div>
          </Card>
          {/* ---- Gráfico Estados das Intervenções por departamento ----*/}
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '60%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <GraficoEstadoIntervencoesDepartamento
                dimensions={dimensions && dimensions.width}
                estadosIntervencoesPorDepartamento={
                  dashInfo.estadosIntervencoesPorDepartamento
                }
              />
            </Box>
          </Card>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box
          style={{
            width: '39%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '44%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <GraficoTaxaSucesso taxaSucesso={dashInfo.taxaSucesso} />
            </Box>
          </Card>
          <span style={{ width: '2%' }} />
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '50%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <GraficoEstadoIntervencoes
                estadosIntervencoes={dashInfo.estadoIntervencoes}
              />
            </Box>
          </Card>
        </Box>
        <Box
          style={{
            width: '60%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '49%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <GraficoValorIntervencoesAdjudicadas
                valorIntervencoesAdjudicadas={
                  dashInfo.valorIntervencoesAdjudicadas
                }
              />
            </Box>
          </Card>
          <Card
            sx={{
              mb: 5,
              p: 2,
              boxShadow: '0px 5px 15px lightgrey',
              width: '49%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <GraficoPercInterAdjudicada
                percentagemIntervencoesAdjudicadas={
                  dashInfo.percentagemIntervencoesAdjudicadas
                }
              />
            </Box>
          </Card>
        </Box>
      </div>
    </>
  );
};

export default DesktopDash;
